//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createRefetchContainer } from "react-relay";
// suggestion-body imports
import { IProps, IContainer, IState } from "./SuggestionBodyExpensiveOrganizer.d";
import {
  suggestionBodyExpensiveOrganizerFragments,
  refetchQuery,
} from "./SuggestionBodyExpensiveOrganizer.gql";
import * as s from "./SuggestionBodyExpensiveOrganizer.styles";
// other components
import { AvatarLogo, AvatarPerson } from "@components/avatar";

//////////////////
// COMPONENT
//////////////////
class SuggestionBodyExpensiveOrganizerCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      person: null,
    };
  }

  public componentDidMount() {
    // load persons for avatars
    this.props.relay.refetch(
      {
        calendarIds: [this.props.suggestionPayload.calendarId],
        orgRelayId: this.props.org.id,
      },
      undefined,
      () => {
        if (
          this.props.org.personsByCalendarIdsErrorable.__typename === "PersonList" &&
          this.props.org.personsByCalendarIdsErrorable.list.length
        ) {
          const person = this.props.org.personsByCalendarIdsErrorable.list[0];
          this.setState({ person });
        }
      },
    );
  }

  public render() {
    const { suggestionPayload, org } = this.props;
    const { person } = this.state;

    return (
      <div style={s.container}>
        <AvatarLogo size={70} />
        <div style={s.plus}>+</div>
        <AvatarPerson
          org={org}
          size={70}
          person={person}
          orgPerson={null}
          backupCalendarId={suggestionPayload.calendarId}
          parentName={"SuggestionBodyExpensiveOrganizer"}
        />
      </div>
    );
  }
}

//////////////////
// RELAY
//////////////////
export const SuggestionBodyExpensiveOrganizer = createRefetchContainer<IContainer>(
  SuggestionBodyExpensiveOrganizerCmpt,
  suggestionBodyExpensiveOrganizerFragments,
  refetchQuery,
);
